import * as React from 'react';

function SvgLatvia(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.726h35.537V.058H0v20.668z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.058h35.537v-8H0v8zM0 21h35.537v-8H0v8z"
        fill="#9F1330"
      />
    </svg>
  );
}

export default SvgLatvia;
